export default {
  path: '/lvy-vip-subscription-agreement',
  component: () => import('../VipAilPaySubscription/VipAilPaySubscription.vue'),
  meta: {
    title: '会员订阅服务协议',
    designWidth: 750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}